import { styled } from 'styled-components';

const HowToPlayPage = () => {
  return <Wrapper>How to play</Wrapper>;
};

const Wrapper = styled.main``;

export { HowToPlayPage };
